<template>
    <div class="container">
        <content-header title="Подготовка к исследованиям"/>
        <div class="left-60px">
            <p style="text-indent: 20px">Для наиболее точного диагностирования заболеваний недостаточно самого
                современного лабораторного оборудования. Точность результатов зависит не только от используемых
                реактивов и аппаратуры, но и от времени и правильности сбора исследуемого материала.</p>
            <p style="text-indent: 20px">При несоблюдении основных правил подготовки к анализам, их результаты могут
                быть значительно искажены. Здесь Вы можете ознакомиться с правилами сдачи анализов, которые помогут
                получить наиболее точный результат.</p>
        </div>
        <div class="divider"></div>
        <div class="flex">
            <div class="box">
                <img src="../../assets/images/staticPages/pdgt_kdl.jpg" alt="pdgt_kdl" height="93" width="140"/>
                <router-link :to="{name: 'Лабораторные исследования'}" class="link"><span>ЛАБОРАТОРНЫЕ</span>
                </router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/pdgt_hlpl.jpg" alt="pdgt_hlpl" height="93" width="140"/>
                <router-link :to="{name: 'Обследование на Helicobacter pylori'}"
                             class="link"><span>Helicobacter pylori</span></router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/pdgt_rent.jpg" alt="pdgt_rent" height="93" width="140"/>
                <router-link :to="{name: 'Рентгенологические исследования'}"
                             class="link"><span>РЕНТГЕНОЛОГИЧЕСКИЕ</span></router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/pdgt_ks.jpg" alt="pdgt_ks" height="93" width="140"/>
                <router-link :to="{name: 'ЭГДС исследования'}" class="link"><span>ЭГДС (КОЛОНОСКОПИЯ)</span>
                </router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/pdgt_uzi.jpg" alt="pdgt_uzi" height="93" width="140"/>
                <router-link :to="{name: 'Ультразвуковые исследования'}" class="link"><span>УЛЬТРАЗВУКОВЫЕ</span>
                </router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/pdgt_fnc.jpg" alt="pdgt_fnc" height="93" width="140"/>
                <router-link :to="{name: 'Функциональная диагностика'}"
                             class="link"><span>ФУНКЦИОНАЛЬНАЯ ДИАГНОСТИКА</span></router-link>
            </div>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <div class="box">
                <img src="../../assets/images/staticPages/breastcancer_whiteshirt_0.jpg" alt="breastcancer_whiteshirt_0"
                     height="93" width="140"/>
                <router-link :to="{name: 'Подготовка к рентгенологическому исследованию млечных протоков'}"
                             class="link"><span>ПОДГОТОВКА К РЕНТГЕНОЛОГИЧЕСКОМУ ИССЛЕДОВАНИЮ МЛЕЧНЫХ ПРОТОКОВ</span>
                </router-link>
            </div>
        </div>
        <div class="inv-divider"></div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "preparation",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 140px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
    margin: 0 auto;
}

.link > span {
    font-size: 14px;
    border-bottom: 1px dotted #006688;
}

.left-30px {
    margin-left: 30px;
}

.left-60px {
    margin-left: 60px;
}

</style>
